import { DrawerContent, DrawerHeader } from '@fountain/fountain-ui-components';
import {
  ChatAltOutlineIcon,
  ChevronLeftOutlineIcon,
  Icon,
  XOutlineIcon,
} from '@fountain/ripple/icon';
import { Tab, Tabs, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import SwipeableViews from 'react-swipeable-views';

import MobileMessagePreview from 'components/MobileMessagePreview';
import WhatsappIcon from 'images/whatsapp-logo.svg';
import { iconLabels } from 'shared/iconLabels';
import { formatPhoneNumber } from 'utils/formatPhoneNumber';

import useStyles from './styles';

interface MessagePreviewDeviceViewProps {
  isWhatsappEnabled: boolean;
  setPreviewMessageOpenForMobile: (
    previewMessageOpenForMobile: boolean,
  ) => void;
  previewMessageOpenForMobile: boolean;
  handleClose: () => void;
  setMobilePreviewIndex: (mobilePreviewIndex: number) => void;
  mobilePreviewIndex: number;
  smsText: string;
  whatsappText: string;
  twilioNumber: number;
}

const MessagePreviewDeviceView: FC<MessagePreviewDeviceViewProps> = ({
  isWhatsappEnabled,
  setPreviewMessageOpenForMobile,
  previewMessageOpenForMobile,
  handleClose,
  setMobilePreviewIndex,
  mobilePreviewIndex,
  smsText,
  whatsappText,
  twilioNumber,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const handleMobilePreviewChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setMobilePreviewIndex(value);
  };

  const handleChangeIndex = (index: number) => {
    setMobilePreviewIndex(index);
  };

  return (
    <>
      {isWhatsappEnabled ? (
        <>
          <DrawerHeader className={classes.messagePreviewHeader}>
            <IconButton
              className={classes.backButton}
              aria-label={intl.formatMessage(iconLabels.back)}
              onClick={() =>
                setPreviewMessageOpenForMobile(!previewMessageOpenForMobile)
              }
            >
              <Icon
                icon={ChevronLeftOutlineIcon}
                size="sm"
                color="neutral-400"
              />
            </IconButton>
            <IconButton
              onClick={handleClose}
              className={classes.closeButton}
              aria-label={intl.formatMessage(iconLabels.close)}
            >
              <Icon icon={XOutlineIcon} size="sm" color="neutral-400" />
            </IconButton>
          </DrawerHeader>
          <SwipeableViews
            enableMouseEvents
            index={mobilePreviewIndex}
            onChangeIndex={handleChangeIndex}
          >
            <div>
              <DrawerContent className={classes.messagePreviewDeviceView}>
                <MobileMessagePreview
                  type="sms"
                  phoneNumber={formatPhoneNumber(twilioNumber)}
                  messageText={smsText || undefined}
                />
              </DrawerContent>
            </div>
            <div>
              <DrawerContent className={classes.messagePreviewDeviceView}>
                <MobileMessagePreview
                  type="sms"
                  phoneNumber={formatPhoneNumber(twilioNumber)}
                  messageText={whatsappText || undefined}
                  isWhatsappPreview
                />
              </DrawerContent>
            </div>
          </SwipeableViews>
          <Tabs
            className={classes.tabs}
            onChange={handleMobilePreviewChange}
            value={mobilePreviewIndex}
            variant="standard"
          >
            <Tab
              label={
                <Typography className={classes.mobilePreviewIcon}>
                  <Icon
                    icon={ChatAltOutlineIcon}
                    size="sm"
                    color="brand"
                    className={classes.tabIcon}
                  />{' '}
                  <span>SMS</span>
                </Typography>
              }
            />
            <Tab
              label={
                <Typography className={classes.mobilePreviewIcon}>
                  <img
                    src={WhatsappIcon}
                    alt="whatsapp preview"
                    className={classes.tabIcon}
                  />{' '}
                  <span>WhatsApp</span>
                </Typography>
              }
            />
          </Tabs>
        </>
      ) : (
        <>
          <DrawerHeader className={classes.messagePreviewHeader}>
            <IconButton
              className={classes.backButton}
              aria-label={intl.formatMessage(iconLabels.back)}
              onClick={() =>
                setPreviewMessageOpenForMobile(!previewMessageOpenForMobile)
              }
            >
              <Icon
                icon={ChevronLeftOutlineIcon}
                size="sm"
                color="neutral-400"
              />
            </IconButton>
            <IconButton
              onClick={handleClose}
              className={classes.closeButton}
              aria-label={intl.formatMessage(iconLabels.close)}
            >
              <Icon icon={XOutlineIcon} size="sm" color="neutral-400" />
            </IconButton>
          </DrawerHeader>
          <DrawerContent className={classes.messagePreviewDeviceView}>
            <MobileMessagePreview
              type="sms"
              phoneNumber={formatPhoneNumber(twilioNumber)}
              messageText={smsText || undefined}
            />
          </DrawerContent>
        </>
      )}
    </>
  );
};

export default MessagePreviewDeviceView;
